// <pry-viewer> + <lum-viewer> — прості 3D-в'юери MRF-заліза (не карти: без міток і фото-граней).
// Спільна фабрика: STL + фініші (+ опційно тату-декалі). FRONT = бік з фрезеруванням/лого = −z
// (pry: y-max бік фрезерований, standup Z=−y ⇒ −z; lumberjack: наскрізне лого читається з +y ⇒ теж −z).
// Тату pry: X.1 (патерн + лого) на фрезерований бік, X.2 — на плоский. Декалі згенеровані з PDF-векторів
// (uploads/1.*.pdf): чорний/синій тонкий штрих = фізичний контур 22×100 мм → рамка реєстрації; червоне
// (заливка або штрих) = патерн. Обидві грані малюються «як видно зовні», без дзеркалення.
(function () {
  const THREE_URL = 'https://unpkg.com/three@0.184.0/build/three.module.js';
  const FINISH_ALL = [
    { id: 'natural', name: 'NATURAL TI',      hex: 0xc6ccd3, sw: '#C6CCD3', rough: 0.36, metal: 0.86, env: 1.35, ink: 0x191b1e },
    { id: 'black',   name: 'BLACK',           hex: 0x17191d, sw: '#17191D', rough: 0.42, metal: 0.55, env: 0.7,  ink: 0xffffff },
    { id: 'orange',  name: 'SURVIVAL ORANGE', hex: 0xdc4d01, sw: '#DC4D01', rough: 0.6,  metal: 0.22, env: 0.85, ink: 0x2a1105 },
    { id: 'camo',    name: 'CAMO GREEN',      hex: 0x2e4a2a, sw: '#2E5B34', rough: 0.64, metal: 0.2,  env: 0.5,  ink: 0xdde3da },
    { id: 'steel',   name: 'STEEL',           hex: 0x8f959c, sw: '#8F959C', rough: 0.3,  metal: 0.95, env: 1.1,  ink: 0x14161a }
  ];
  const ALL_FIN = ['natural', 'black', 'orange', 'camo', 'steel'];
  const NZ = (side) => (side === 'A' ? -1 : 1);   // FRONT (milled / logo) face lives at -z
  // корпоративні подарунки: КОЖЕН дизайн доступний в усіх покриттях
  const PRY_TATS = [
    { id: 'mrf',    name: 'MRF',             b: false, fin: ALL_FIN },
    { id: 'maori',  name: 'MAORI',           b: true,  fin: ALL_FIN },
    { id: 'sakura', name: 'JAPANESE SAKURA', b: true,  fin: ALL_FIN },
    { id: 'aztec',  name: 'AZTEC WARRIOR',   b: true,  fin: ALL_FIN },
    { id: 'dream',  name: 'DREAMCATCHER',    b: true,  fin: ALL_FIN },
    { id: 'steam',  name: 'STEAMPUNK GEARS', b: true,  fin: ALL_FIN },
    { id: 'terra',  name: 'TERRA INCOGNITA', b: true,  fin: ALL_FIN },
    { id: 'pun',    name: 'THE PUNISHER',    b: true,  fin: ALL_FIN }
  ];

  function parseSTL(buf) {
    const dv = new DataView(buf);
    const tri = dv.getUint32(80, true);
    if (84 + tri * 50 !== buf.byteLength) throw new Error('only binary STL supported');
    const pos = new Float32Array(tri * 9), nor = new Float32Array(tri * 9);
    for (let i = 0; i < tri; i++) {
      const o = 84 + i * 50;
      const nx = dv.getFloat32(o, true), ny = dv.getFloat32(o + 4, true), nz = dv.getFloat32(o + 8, true);
      for (let v = 0; v < 3; v++) {
        const p = o + 12 + v * 12, k = i * 9 + v * 3;
        pos[k] = dv.getFloat32(p, true); pos[k + 1] = dv.getFloat32(p + 4, true); pos[k + 2] = dv.getFloat32(p + 8, true);
        nor[k] = nx; nor[k + 1] = ny; nor[k + 2] = nz;
      }
    }
    return { pos, nor };
  }

  function defineViewer(cfg) {
    class SimpleViewer extends HTMLElement {
      connectedCallback() {
        if (this._up) { this._revive(); return; }
        this._up = true;
        this.style.cssText = 'position:relative; display:block; width:100%; height:100%; min-height:280px; background:radial-gradient(120% 100% at 50% 42%, #262C33 0%, #1A1E24 58%, #11141A 100%); touch-action:none;';
        this.innerHTML =
          '<canvas style="display:block; width:100%; height:100%; cursor:grab;"></canvas>' +
          '<svg data-lead style="position:absolute; inset:0; width:100%; height:100%; pointer-events:none; overflow:visible;"><line stroke="#FF6B2C" stroke-width="1.5" stroke-dasharray="4 3" opacity="0"></line><circle r="3" fill="#FF6B2C" opacity="0"></circle></svg>' +
          '<div data-labels style="position:absolute; inset:0; pointer-events:none;"></div>' +
          '<div data-hint style="position:absolute; left:12px; bottom:12px; font-family:\'IBM Plex Mono\',monospace; font-size:11px; letter-spacing:0.1em; color:rgba(236,237,238,0.72); background:rgba(11,12,14,0.72); padding:4px 8px;">LOADING 3D…</div>' +
          '<div data-btns style="position:absolute; right:12px; top:12px; display:flex; gap:6px;"></div>';
        this._revive = () => {
          if (!this._tickFn || !this.isConnected) return;
          if (this._beat != null && performance.now() - this._beat < 250) return;
          if (this._raf != null) cancelAnimationFrame(this._raf);
          this._raf = null;
          this._tickFn();
        };
        this._watchdog = setInterval(() => {
          if (this.isConnected && this.clientWidth > 0 && this._tickFn && (this._beat == null || performance.now() - this._beat > 400)) this._revive();
        }, 500);
        this.canvas = this.querySelector('canvas');
        this.labels = this.querySelector('[data-labels]');
        this.lead = this.querySelector('[data-lead] line');
        this.leadDot = this.querySelector('[data-lead] circle');
        this.hint = this.querySelector('[data-hint]');
        this._mkBtn = (label, fn) => {
          const b = document.createElement('button');
          b.textContent = label;
          b.style.cssText = "cursor:pointer; font-family:'IBM Plex Mono',monospace; font-size:11px; letter-spacing:0.06em; color:#ECEDEE; background:rgba(11,12,14,0.78); border:1px solid #33383F; border-radius:9px; padding:7px 10px;";
          b.onmouseenter = () => { b.style.borderColor = '#FF6B2C'; };
          b.onmouseleave = () => { b.style.borderColor = '#33383F'; };
          b.onclick = fn;
          this.querySelector('[data-btns]').appendChild(b);
          return b;
        };
        this.boot().catch(e => { this.hint.textContent = '3D FAILED: ' + e.message; console.error(cfg.tag, e); });
      }

      async boot() {
        const THREE = await import(THREE_URL);
        const W = cfg.W, H = cfg.H, T = cfg.T;
        const renderer = new THREE.WebGLRenderer({ canvas: this.canvas, antialias: true, alpha: true, preserveDrawingBuffer: true });
        renderer.setPixelRatio(Math.min(devicePixelRatio, 1.75));
        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(38, 1, 1, 3000);
        scene.add(new THREE.HemisphereLight(0xf2f4f7, 0x4a5059, 0.55));
        const key = new THREE.DirectionalLight(0xffffff, 1.0); key.position.set(70, 130, 150); scene.add(key);
        const rim = new THREE.DirectionalLight(0xcfe0f5, 1.05); rim.position.set(-90, -50, -130); scene.add(rim);
        const fill = new THREE.DirectionalLight(0xffffff, 0.5); fill.position.set(-40, 90, -60); scene.add(fill);
        (() => {
          const c = document.createElement('canvas'); c.width = 512; c.height = 256;
          const x = c.getContext('2d');
          const gr = x.createLinearGradient(0, 0, 0, 256);
          gr.addColorStop(0, '#eef2f7'); gr.addColorStop(0.5, '#9aa3ad'); gr.addColorStop(1, '#2a2e33');
          x.fillStyle = gr; x.fillRect(0, 0, 512, 256);
          x.fillStyle = 'rgba(255,255,255,0.95)'; x.fillRect(60, 30, 150, 60);
          x.fillStyle = 'rgba(210,225,245,0.7)'; x.fillRect(330, 60, 90, 90);
          const tex = new THREE.CanvasTexture(c);
          tex.mapping = THREE.EquirectangularReflectionMapping;
          const pm = new THREE.PMREMGenerator(renderer);
          scene.environment = pm.fromEquirectangular(tex).texture;
          tex.dispose(); pm.dispose();
        })();
        const FINISH = FINISH_ALL.filter(f => cfg.finishes.includes(f.id));
        const mats = {};
        FINISH.forEach(f => { mats[f.id] = new THREE.MeshStandardMaterial({ name: cfg.tag + '-' + f.id, color: f.hex, metalness: f.metal, roughness: f.rough, envMapIntensity: f.env }); });

        const { pos, nor } = parseSTL(await (await fetch(cfg.stl)).arrayBuffer());
        const g = new THREE.BufferGeometry();
        g.setAttribute('position', new THREE.BufferAttribute(pos, 3));
        g.setAttribute('normal', new THREE.BufferAttribute(nor, 3));
        g.computeBoundingBox();
        const size = new THREE.Vector3(); g.boundingBox.getSize(size);
        const scale = H / Math.max(size.x, size.y, size.z);
        g.scale(scale, scale, scale);
        g.computeBoundingBox();
        const ctr = new THREE.Vector3(); g.boundingBox.getCenter(ctr);
        g.translate(-ctr.x, -ctr.y, -ctr.z);
        g.rotateX(-Math.PI / 2);
        g.computeVertexNormals();
        const body = new THREE.Mesh(g, mats[FINISH[0].id]);
        body.name = cfg.tag;
        scene.add(body);

        this.decals = [];
        let setTat = null;
        if (cfg.tats) {
          const loader = new THREE.TextureLoader();
          const texCache = {};
          const texOf = (file) => {
            if (!texCache[file]) {
              const t = loader.load(file, () => { this._dirty = true; if (this.refresh) this.refresh(); });
              t.anisotropy = 8;
              texCache[file] = t;
            }
            return texCache[file];
          };
          const mkDecal = (sign, face) => {
            const m = new THREE.Mesh(new THREE.PlaneGeometry(W, H), new THREE.MeshBasicMaterial({ transparent: true, opacity: 0.96, depthWrite: false }));
            m.position.z = sign * (T / 2 + 0.03);
            if (sign < 0) m.rotation.y = Math.PI;
            m.name = 'tattoo-' + face;
            scene.add(m);
            return m;
          };
          const decalA = mkDecal(-1, 'a'), decalB = mkDecal(1, 'b');   // A (X.1, з лого) на фрезерованому −z
          this.decals = [decalA, decalB];
          setTat = (i) => {
            const t = cfg.tats[i];
            decalA.material.map = texOf('https://mrf.tools/cdn/shop/files/mrf26-pry-tat-' + t.id + '-a.png');
            decalA.material.needsUpdate = true;
            decalA.visible = true;
            if (t.b) {
              decalB.material.map = texOf('https://mrf.tools/cdn/shop/files/mrf26-pry-tat-' + t.id + '-b.png');
              decalB.material.needsUpdate = true;
              decalB.visible = true;
            } else decalB.visible = false;
            this._tat = t.id;
            this._dirty = true;
            (this._tatPills || []).forEach((p, k) => {
              p.style.borderColor = k === i ? '#FF6B2C' : '#262A30';
              p.style.color = k === i ? '#FF6B2C' : '#9BA1A8';
              p.style.background = k === i ? '#16181C' : 'transparent';
            });
            if (this._tatTag) this._tatTag.textContent = t.b ? 'DOUBLE-SIDED TATTOO' : 'ONE SIDE · MRF LOGO';
            if (this._finDots) {   // у кожного дизайну свої 3 фініші (артборд PRYBAR L)
              this._finDots.forEach((d, k) => { d.style.display = t.fin.includes(FINISH[k].id) ? '' : 'none'; });
              if (!t.fin.includes(this._finish)) this._setFinish(FINISH.findIndex(f => f.id === t.fin[0]));
            }
            if (this.refresh) this.refresh();
          };
        }

        const FRONT_T = Math.PI + 0.35;   // лого/фрезерований бік на −z
        let theta = FRONT_T, phi = 1.25, r = 300, drag = null, auto = true, home = FRONT_T, sway = 0;
        this._fit = () => {
          const w = this.clientWidth || 1, h = this.clientHeight || 1;
          const vFov = camera.fov * Math.PI / 180;
          const need = Math.max(H / 2 / Math.tan(vFov / 2), W / 2 / Math.tan(vFov / 2) / (w / h));
          r = need * 1.24;
        };
        this._fit();
        const place = () => {
          camera.position.set(r * Math.sin(phi) * Math.sin(theta), r * Math.cos(phi), r * Math.sin(phi) * Math.cos(theta));
          camera.lookAt(0, 0, 0);
        };
        const pts = new Map();
        let pinch = 0;
        const spread = () => { const a = [...pts.values()]; return Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y); };
        this.canvas.addEventListener('pointerdown', (e) => {
          pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
          auto = false; this._touched = true;
          if (pts.size === 2) { pinch = spread(); drag = null; }
          else { drag = { x: e.clientX, y: e.clientY }; this.canvas.style.cursor = 'grabbing'; }
          this._moved = 0; this._multi = pts.size >= 2;
          try { this.canvas.setPointerCapture(e.pointerId); } catch (err) {}
        });
        this.canvas.addEventListener('pointermove', (e) => {
          if (!pts.has(e.pointerId)) return;
          pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
          if (pts.size >= 2) {
            this._multi = true;
            const d = spread();
            if (pinch > 0 && d > 0) r = Math.min(560, Math.max(120, r * (pinch / d)));
            pinch = d;
            return;
          }
          if (!drag) return;
          this._moved += Math.abs(e.clientX - drag.x) + Math.abs(e.clientY - drag.y);
          theta -= (e.clientX - drag.x) * 0.008;
          phi = Math.min(Math.PI - 0.12, Math.max(0.12, phi - (e.clientY - drag.y) * 0.008));
          drag = { x: e.clientX, y: e.clientY };
        });
        const stop = (e) => {
          pts.delete(e.pointerId);
          if (pts.size < 2) pinch = 0;
          if (pts.size === 1) { const a = [...pts.values()][0]; drag = { x: a.x, y: a.y }; }
          if (pts.size === 0) { drag = null; this.canvas.style.cursor = window['__' + cfg.tag + 'cal'] ? 'crosshair' : 'grab'; }
        };
        this.canvas.addEventListener('pointerup', stop);
        this.canvas.addEventListener('pointerup', (e) => {
          // a tap on the part in placement mode drops the armed marker; a real drag still spins
          const n = window['__' + cfg.tag + 'cal'];
          if (n && !this._multi && this._moved < 7 && pts.size <= 1) this._dropAt(e.clientX, e.clientY, n, true);
        });
        this.canvas.addEventListener('pointercancel', stop);
        let fly = null;
        this.zoomBy = (f) => { this._touched = true; auto = false; fly = null; r = Math.min(560, Math.max(120, r * f)); this._dirty = true; };
        this.cancelDrag = () => { drag = null; pts.clear(); pinch = 0; };
        this.canvas.addEventListener('wheel', (e) => { e.preventDefault(); this._touched = true; r = Math.min(560, Math.max(120, r + e.deltaY * 0.35)); }, { passive: false });

        let pt = null, pp = null, pr = null;
        this._dirty = true;
        this.flyTo = (side) => { home = (side === 'A' ? Math.PI : 0) + 0.35; fly = { theta: home, phi: 1.25 }; auto = false; };
        this.canvas.addEventListener('pointerdown', () => { fly = null; }, true);
        this._mkBtn('FRONT', () => this.flyTo('A'));
        this._mkBtn('BACK', () => this.flyTo('B'));

        // ── tool markers: same machinery as the card explorers (mm on face A → 3D anchor) ──
        this._hit = (cx, cy) => {
          const rect = this.canvas.getBoundingClientRect();
          if (!rect.width || !rect.height || Math.abs(camera.position.z) < 6) return null;
          const side = camera.position.z < 0 ? 'A' : 'B';
          const v3 = new THREE.Vector3(((cx - rect.left) / rect.width) * 2 - 1, -(((cy - rect.top) / rect.height) * 2 - 1), 0.5);
          v3.unproject(camera);
          const dir = v3.sub(camera.position);
          if (Math.abs(dir.z) < 1e-6) return null;
          const k = (NZ(side) * (T / 2) - camera.position.z) / dir.z;
          if (k < 0) return null;
          const wx = camera.position.x + dir.x * k, wy = camera.position.y + dir.y * k;
          const mx = NZ(side) > 0 ? wx + W / 2 : W / 2 - wx;
          return { side: side, mx: Math.max(0, Math.min(W, mx)), my: Math.max(0, Math.min(H, H / 2 - wy)) };
        };
        this._dropAt = (cx, cy, n, advance) => {
          const h = this._hit(cx, cy);
          if (!h) return;
          const mk = (this.markers || []).find(m => m.n === n);
          if (mk) {
            const s2 = NZ(h.side);
            mk.side = h.side;
            mk.p = [s2 > 0 ? h.mx - W / 2 : W / 2 - h.mx, H / 2 - h.my, s2 * (T / 2 + 0.2)];
            mk.el.dataset.solid = '1';
            this._dirty = true;
          }
          const place = window['__' + cfg.tag + 'place'];
          if (place) place(n, h.side, h.mx, h.my, advance);
        };
        this.buildLabels();

        const host = document.getElementById('finishRow');
        const bar = document.createElement('div');
        bar.setAttribute('data-finish-for', this.id || 'v-' + cfg.tag);
        bar.style.cssText = host
          ? 'display:flex; flex-direction:column; gap:10px; border:1px solid #262A30; border-radius:12px; padding:10px 12px; background:#121417;'
          : 'position:absolute; left:12px; bottom:44px; z-index:3; display:flex; flex-direction:column; gap:10px; background:rgba(11,12,14,0.82); border-radius:14px; padding:10px 12px;';
        const frow = document.createElement('div');
        frow.style.cssText = 'display:flex; align-items:center; gap:12px; flex-wrap:wrap;';
        const fcap = document.createElement('span');
        fcap.textContent = 'FINISH';
        fcap.style.cssText = "font-family:'IBM Plex Mono',monospace; font-size:9px; letter-spacing:0.14em; color:rgba(236,237,238,0.55);";
        frow.appendChild(fcap);
        const dots = [];
        const nameTag = document.createElement('span');
        nameTag.style.cssText = "font-family:'IBM Plex Mono',monospace; font-size:11.5px; letter-spacing:0.1em; color:#ECEDEE; white-space:nowrap;";
        const setFinish = (i) => {
          const f = FINISH[i];
          body.material = mats[f.id];
          this.decals.forEach(d => d.material.color.set(f.ink));
          nameTag.textContent = f.name;
          dots.forEach((d, k) => {
            d.style.transform = k === i ? 'scale(1.1)' : 'scale(1)';
            d.style.boxShadow = k === i ? '0 0 0 2px #FF6B2C' : '0 0 0 1px rgba(236,237,238,0.3)';
          });
          this._finish = f.id;
          this._dirty = true;
          if (this.refresh) this.refresh();
        };
        FINISH.forEach((f, i) => {
          const d = document.createElement('button');
          d.title = f.name;
          d.setAttribute('aria-label', f.name);
          d.style.cssText = 'cursor:pointer; width:36px; height:23px; border-radius:999px; border:0; padding:0; background:' + f.sw + '; transition:transform .16s ease, box-shadow .16s ease;';
          d.onclick = () => setFinish(i);
          frow.appendChild(d); dots.push(d);
        });
        this._setFinish = setFinish;
        this._finDots = dots;
        frow.appendChild(nameTag);
        bar.appendChild(frow);
        if (cfg.tats) {
          const trow = document.createElement('div');
          trow.style.cssText = 'display:flex; align-items:center; gap:6px; flex-wrap:wrap;';
          const tcap = document.createElement('span');
          tcap.textContent = 'TATTOO';
          tcap.style.cssText = "font-family:'IBM Plex Mono',monospace; font-size:9px; letter-spacing:0.14em; color:rgba(236,237,238,0.55); margin-right:6px;";
          trow.appendChild(tcap);
          this._tatPills = [];
          cfg.tats.forEach((t, i) => {
            const p = document.createElement('button');
            p.textContent = t.name;
            p.style.cssText = "cursor:pointer; border-radius:9px; padding:6px 10px; background:transparent; color:#9BA1A8; border:1px solid #262A30; font-family:'IBM Plex Mono',monospace; font-size:10px; letter-spacing:0.08em;";
            p.onmouseenter = () => { if (this._tat !== t.id) p.style.borderColor = '#FF6B2C'; };
            p.onmouseleave = () => { if (this._tat !== t.id) p.style.borderColor = '#262A30'; };
            p.onclick = () => setTat(i);
            trow.appendChild(p); this._tatPills.push(p);
          });
          this._tatTag = document.createElement('span');
          this._tatTag.style.cssText = "font-family:'IBM Plex Mono',monospace; font-size:10px; letter-spacing:0.1em; color:#565C64;";
          trow.appendChild(this._tatTag);
          bar.appendChild(trow);
        }
        (host || this).appendChild(bar);
        setFinish(0);
        if (setTat) setTat(0);

        this.hint.textContent = 'DRAG TO SPIN · PINCH OR SCROLL TO ZOOM · TAP A NUMBER';
        const V3 = new THREE.Vector3(), NRM = new THREE.Vector3(), TOCAM = new THREE.Vector3();
        const put = (mk, x, y, op) => {
          x = Math.round(x * 10) / 10; y = Math.round(y * 10) / 10; op = Math.round(op * 100) / 100;
          if (mk.tx === x && mk.ty === y && mk.op === op) return;
          mk.tx = x; mk.ty = y; mk.op = op;
          mk.el.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) translate(-50%,-50%)';
          mk.el.style.opacity = String(op);
        };
        const tick = () => {
          if (!this.isConnected) { this._raf = null; return; }
          this._beat = performance.now();
          this._raf = requestAnimationFrame(tick);
          const w = this.clientWidth, h = this.clientHeight;
          if (!w || !h || this._vis === false) return;
          if (this.canvas.width !== Math.round(w * renderer.getPixelRatio()) || this.canvas.height !== Math.round(h * renderer.getPixelRatio())) {
            renderer.setSize(w, h, false);
            camera.aspect = w / h; camera.updateProjectionMatrix();
            this._dirty = true;
            if (!this._touched) this._fit();
          }
          if (auto && !window['__' + cfg.tag + 'cal']) {
            sway += 0.0075;
            const amp = 0.3 * Math.max(0, 1 - sway / 5.4);
            theta = home + Math.sin(sway) * amp;
            if (amp === 0) { auto = false; theta = home; }
          }
          const calOn = !!window['__' + cfg.tag + 'cal'];
          if (calOn !== this._calWas) {
            this._calWas = calOn;
            this.canvas.style.cursor = calOn ? 'crosshair' : 'grab';
            this.hint.textContent = calOn
              ? 'PLACEMENT · TAP THE PART TO SET THE ARMED NUMBER · DRAG A MARKER TO NUDGE'
              : 'DRAG TO SPIN · PINCH OR SCROLL TO ZOOM · TAP A NUMBER';
            this.buildLabels();
          }
          if (fly) {
            let dt = fly.theta - theta;
            while (dt > Math.PI) dt -= 2 * Math.PI;
            while (dt < -Math.PI) dt += 2 * Math.PI;
            theta += dt * 0.12; phi += (fly.phi - phi) * 0.12;
            if (Math.abs(dt) < 0.01 && Math.abs(fly.phi - phi) < 0.01) fly = null;
          }
          if (window['__' + cfg.tag + 'block'] !== this._blk || window['__' + cfg.tag + 'stamp'] !== this._stamp) this.buildLabels();
          const actNow = window['__' + cfg.tag + 'active'];
          if (actNow !== this._act) { this._act = actNow; this.paintActive(); }
          if (!this._dirty && pt !== null && Math.abs(theta - pt) < 1e-4 && Math.abs(phi - pp) < 1e-4 && Math.abs(r - pr) < 1e-4) return;
          this._dirty = false; pt = theta; pp = phi; pr = r;
          place();
          this._faceNow = camera.position.z < 0 ? 'A' : 'B';
          renderer.render(scene, camera);
          let leadOn = false;
          (this.markers || []).forEach(mk => {
            V3.set(mk.p[0], mk.p[1], mk.p[2]);
            NRM.set(0, 0, NZ(mk.side));
            TOCAM.copy(camera.position).sub(V3).normalize();
            const facing = NRM.dot(TOCAM);
            V3.project(camera);
            const sx = (V3.x * 0.5 + 0.5) * w, sy = (-V3.y * 0.5 + 0.5) * h;
            const act = mk.n === this._act;
            const front = facing > 0.12 && V3.z < 1;
            if (!front && !act) { if (mk.vis !== 0) { mk.vis = 0; mk.el.style.display = 'none'; } return; }
            if (mk.vis !== 1) { mk.vis = 1; mk.el.style.display = 'flex'; }
            if (front) {
              put(mk, sx, sy, Math.min(1, 0.35 + facing) * (mk.off && !act ? 0.4 : 1));
              return;
            }
            const dx = sx - w / 2, dy = sy - h / 2, len = Math.hypot(dx, dy) || 1;
            const lx = Math.max(18, Math.min(w - 18, sx + dx / len * 46)), ly = Math.max(18, Math.min(h - 18, sy + dy / len * 46));
            put(mk, lx, ly, 1);
            this.lead.setAttribute('x1', sx); this.lead.setAttribute('y1', sy);
            this.lead.setAttribute('x2', lx); this.lead.setAttribute('y2', ly);
            this.leadDot.setAttribute('cx', sx); this.leadDot.setAttribute('cy', sy);
            leadOn = true;
          });
          const lop = leadOn ? '0.9' : '0';
          if (this._lop !== lop) { this._lop = lop; this.lead.setAttribute('opacity', lop); this.leadDot.setAttribute('opacity', lop); }
        };
        this._tickFn = tick;
        if (window.IntersectionObserver && !this._io) {
          this._io = new IntersectionObserver((es) => {
            const vis = es.some(e => e.isIntersecting);
            if (vis && this._vis === false) { this._dirty = true; this._revive(); }
            this._vis = vis;
          }, { rootMargin: '240px' });
          this._io.observe(this);
        }
        this.refresh = () => {
          if (!this.isConnected || !this._tickFn) return;
          if (this._raf != null) cancelAnimationFrame(this._raf);
          this._raf = null;
          tick();
        };
        tick();
      }

      buildLabels() {
        if (this._dragN != null) { this.paintActive(); return; }   // never swap the element under a live drag
        const D = window[cfg.data] || { blocks: [] };
        const marks = window['__' + cfg.tag + 'marks'] || {};
        const W = cfg.W, H = cfg.H, T = cfg.T;
        this.markers = [];
        if (!this.labels) return;
        this.labels.innerHTML = '';
        this._blk = window['__' + cfg.tag + 'block'];
        this._stamp = window['__' + cfg.tag + 'stamp'];
        const cal = !!window['__' + cfg.tag + 'cal'];
        D.blocks.forEach((b, bi) => b.tools.forEach(t => {
          const off = this._blk != null && bi !== this._blk;
          const m = marks[t.n];
          const f = m && m.mx != null
            ? { mx: m.mx, my: m.my, side: m.side }
            : (window.CardMap ? Object.assign({ side: t.side || 'A' }, window.CardMap.mmOf(cfg.tag, t)) : { mx: 0, my: 0, side: 'A' });
          const n = NZ(f.side);
          const p = [n > 0 ? f.mx - W / 2 : W / 2 - f.mx, H / 2 - f.my, n * (T / 2 + 0.2)];
          const el = document.createElement('button');
          el.textContent = String(t.n).padStart(2, '0');
          el.title = t.name;
          el.style.cssText = "position:absolute; left:0; top:0; opacity:0; will-change:transform; pointer-events:auto; cursor:" + (cal ? 'grab' : 'pointer') + "; width:" + (off ? 17 : 26) + "px; height:" + (off ? 17 : 26) + "px; padding:0; border-radius:50%; font-family:'IBM Plex Mono',monospace; font-size:" + (off ? 8 : 10.5) + "px; font-weight:600; display:flex; align-items:center; justify-content:center; border:1.5px solid rgba(236,237,238,0.8); background:rgba(11,12,14,0.66); color:#ECEDEE; touch-action:none;";
          el.dataset.solid = '1';
          el.onclick = () => { const s = window['__' + cfg.tag + 'select']; if (!cal && s) s(t.n); };
          if (cal) {
            el.onpointerdown = (e) => {
              e.stopPropagation(); e.preventDefault();
              try { el.setPointerCapture(e.pointerId); } catch (err) {}
              this._dragN = t.n;
              const s = window['__' + cfg.tag + 'select']; if (s) s(t.n);
            };
            el.onpointermove = (e) => { if (this._dragN === t.n) this._dropAt(e.clientX, e.clientY, t.n, false); };
            el.onpointerup = (e) => { e.stopPropagation(); this._dragN = null; };
            el.onpointercancel = () => { this._dragN = null; };
          }
          this.labels.appendChild(el);
          this.markers.push({ n: t.n, side: f.side, p: p, el: el, off: off });
        }));
        this._dirty = true;
        this.paintActive();
      }

      paintActive() {
        this._dirty = true;
        const act = window['__' + cfg.tag + 'active'];
        (this.markers || []).forEach(mk => {
          const on = mk.n === act;
          mk.el.style.borderColor = on ? '#FF6B2C' : 'rgba(236,237,238,0.8)';
          mk.el.style.background = on ? '#FF6B2C' : 'rgba(11,12,14,0.66)';
          mk.el.style.color = on ? '#0B0C0E' : '#ECEDEE';
          mk.el.style.zIndex = on ? '5' : (mk.off ? '1' : '2');
          mk.el.style.width = mk.el.style.height = on ? '30px' : (mk.off ? '17px' : '26px');
        });
        this._act = act;
        const a = (this.markers || []).find(m => m.n === act);
        if (!a || this._dragN != null) return;
        if (this._lastAct === undefined) { this._lastAct = act; return; }
        if (this._lastAct !== act) {
          this._lastAct = act;
          if (window['__' + cfg.tag + 'cal'] && this._faceNow === a.side) return;
          if (this.flyTo) this.flyTo(a.side);
        }
      }

      disconnectedCallback() { if (this._raf != null) cancelAnimationFrame(this._raf); this._raf = null; clearInterval(this._watchdog); if (this._io) { this._io.disconnect(); this._io = null; } }
    }
    if (!window.customElements.get(cfg.tag + '-viewer')) window.customElements.define(cfg.tag + '-viewer', SimpleViewer);
  }

  defineViewer({ tag: 'pry', data: 'PRY', stl: 'https://mrf.tools/cdn/shop/files/mrf26-pry.stl?v=b3', W: 22, H: 100, T: 5, tats: PRY_TATS, finishes: ALL_FIN });
  defineViewer({ tag: 'lum', data: 'LUM', stl: 'https://mrf.tools/cdn/shop/files/mrf26-lum.stl?v=b3', W: 55, H: 85, T: 2, tats: null, finishes: ['natural', 'black', 'orange'] });
})();
